import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Button, ButtonGroup } from 'react-bootstrap';
import AssigneeSelect from './AssigneeSelect';
import PrioritiesToolbar from './PrioritiesToolbar';
import StatesToolbar from './StatesToolbar';
import NotificationsToolbar from './NotificationsToolbar';
import TasksToolbar from './TasksToolbar';
// import ValuePropositionToolbar from './ValuePropositionToolbar';
import CategoryToolbar from './CategoryToolbar';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter } from 'react-router-dom';
import ButtonWithConfirmation from '../common_components/ButtonWithConfirmation';

@injectIntl
@inject('rootStore', 'authorizationsStore', 'feedbackChainsStore')
@observer
@withRouter
export default class FeedbackChainControlPanel extends React.Component {
  render() {
    const {
      intl,
      feedbackChain,
      authorizationsStore,
      feedbackChainsStore,
    } = this.props;

    feedbackChainsStore.setCurrentFeedbackChain(feedbackChain);
    //console.log(this.props.authorizationsStore);

    return (
      <div className="control-panel">
        <AssigneeSelect feedbackChain={feedbackChain} />
        <PrioritiesToolbar feedbackChain={feedbackChain} />
        <StatesToolbar feedbackChain={feedbackChain} />
        <CategoryToolbar feedbackChain={feedbackChain} />
        <NotificationsToolbar feedbackChain={feedbackChain} />
        {authorizationsStore.canSeeTasks() && (
          <div>
            <hr />
            <TasksToolbar feedbackChain={feedbackChain} />
          </div>
        )}

        <hr />

        {this.props.authorizationsStore.canEditFeedback(feedbackChain) && (
          <ButtonWithConfirmation
            dropdownClassname="igsupport-delete-button"
            toggleButtonClassName="igsupport-delete-button"
            confirmationMessage={intl.formatMessage({
              id: 'default_delete_confirmation',
            })}
            option1Label={intl.formatMessage({
              id: 'default_delete_cancel_label',
            })}
            option2Label={intl.formatMessage({
              id: 'default_delete_confirm_label',
            })}
            onOption2Select={this.handleDeleteButtonClick}
            dropup
          >
            <i className="fa fa-trash" aria-hidden="true" />
            &nbsp;
            {intl.formatMessage({ id: 'delete' })}
          </ButtonWithConfirmation>
        )}

        <LinkContainer
          to={
            '/' +
            intl.locale +
            '/gstartup/' +
            this.props.rootStore.startupId +
            '/igsupport/'
          }
          activeClassName={'dont-show-as-active'}
        >
          <Button bsStyle="primary" block active={false}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            &nbsp;
            {intl.formatMessage({ id: 'see_other_supports' })}
          </Button>
        </LinkContainer>

        <ButtonGroup style={{ marginTop: 20 }} justified>
          <LinkContainer
            to={
              '/' +
              intl.locale +
              '/gstartup/' +
              this.props.rootStore.startupId +
              '/igsupport/chain/' +
              feedbackChainsStore.move(0).id
            }
            activeClassName={'dont-show-as-active'}
          >
            <Button
              disabled={feedbackChainsStore.move(0).disabled}
              active={false}
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              &nbsp;
              {intl.formatMessage({ id: 'previous_support' })}
            </Button>
          </LinkContainer>

          <LinkContainer
            to={
              '/' +
              intl.locale +
              '/gstartup/' +
              this.props.rootStore.startupId +
              '/igsupport/chain/' +
              feedbackChainsStore.move(1).id
            }
            activeClassName={'dont-show-as-active'}
          >
            <Button
              disabled={feedbackChainsStore.move(1).disabled}
              active={false}
            >
              {intl.formatMessage({ id: 'next_support' })}
              &nbsp;
              <i className="fa fa-arrow-right" aria-hidden="true" />
            </Button>
          </LinkContainer>
        </ButtonGroup>
      </div>
    );
  }

  handleDeleteButtonClick = () => {
    const { rootStore } = this.props;
    this.props.history.push(
      '/' +
        rootStore.localeStore.locale +
        '/gstartup/' +
        rootStore.startupId +
        '/igsupport',
    );
    this.props.feedbackChain.destroy();
  };
}
